import React from "react";

const LoadingDots = ({ style }) => {
	return (
		<div className="d-flex dot-container">
			<span style={style} className="dot animate-bounce delay-0"></span>
			<span style={style} className="dot animate-bounce delay-200"></span>
			<span style={style} className="dot animate-bounce delay-400"></span>
		</div>
	);
};

export default LoadingDots;
